import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse, LoadState } from "../common";
import { getToken } from "../../features/user/UserAvatar";

export enum HomeworkDone {
    Unknown = 0,
    Yes = 1,
    No = 2,
}

export interface HomeworkCheckInfo {
    id: number;
    homeworkId: number;
    schoolId: number;
    classroomId: number;
    studentId: number;
    doneDate: string;
    done: HomeworkDone;
}
